"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-PhotomeasureButton'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        transform: 'rotate(-90deg)'
    },
    _a);
//# sourceMappingURL=photomeasure.button.style.js.map